(function () {
  if (window.akArthleticsPointerPreviewBound) return;
  window.akArthleticsPointerPreviewBound = true;

  var active = null;
  var lastX = null;
  var lastY = null;
  var selector = '.ak-ca-desktop-window, .ak-ca-mobile';

  function reset() {
    if (active) active.classList.remove('ak-ca-pointer-colour');
    active = null;
  }

  document.addEventListener('pointermove', function (event) {
    if (!event.isTrusted || event.pointerType !== 'mouse') return;
    var moved = lastX === null
      ? Boolean(event.movementX || event.movementY)
      : event.clientX !== lastX || event.clientY !== lastY;
    lastX = event.clientX;
    lastY = event.clientY;
    // Scrolling can produce pointer events at unchanged screen coordinates.
    // Neither those events nor pointerenter may reveal the colour treatment.
    if (!moved) return;

    var hit = document.elementFromPoint(lastX, lastY);
    var next = hit && hit.closest(selector);
    if (next === active) return;
    reset();
    if (next) {
      active = next;
      active.classList.add('ak-ca-pointer-colour');
    }
  }, { passive: true });

  // A stationary pointer must never retain or acquire colour while scrolling.
  window.addEventListener('scroll', reset, { capture: true, passive: true });
  window.addEventListener('wheel', reset, { passive: true });
  window.addEventListener('resize', reset, { passive: true });
  window.addEventListener('blur', reset);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) reset();
  });
  document.addEventListener('pointerout', function (event) {
    if (!event.relatedTarget) reset();
  }, { passive: true });
})();
